/* eslint-disable no-use-before-define */
import React, { useState } from 'react';
import { Grid, TextField, FormHelperText } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import {useStyles} from './style';

export default function FormAutocompletarMultiple(props) {
  const classes = useStyles(),
  [arrayDeDatos] = useState(props.list),
  fixedOptions = [arrayDeDatos],
  [value, setValue] = useState([]);

  return (
    <>
     {props.showMultiSelect && (
        <Grid className={classes.grid}>
          <Autocomplete
            multiple
            id="tags-standard"
            value={value}
            onChange={(event, newValue) => {
              setValue([
                ...newValue?.filter((option) => fixedOptions.indexOf(option) === -1),
              ]);
              props.handleChangeMultiSelect(newValue, props.name)
            }}
            options={arrayDeDatos}
            getOptionLabel={(option) => option.name}
            defaultValue={props.defaultValue||[]}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label={props.label || ""}
                placeholder={props.placeholder || ""}
                className={classes.textField}
              />
            )}
          />
          {(props.isError) ? <FormHelperText className="Mui-error" id="component-error-text">{props.errorMessages}</FormHelperText> : null }
        </Grid>
      )}
    </>
  );
}

FormAutocompletarMultiple.defaultProps = {
  showMultiSelect: true,
}